import Vue from 'vue'
import App from './App'
import router from './router'
import VueGtag from 'vue-gtag'
// export for others scripts to use

Vue.use(VueGtag, {
  config: { id: '##' },
  enabled: false
}, router)

Vue.config.productionTip = false

/* eslint-disable no-new */
const _vue = new Vue({
  el: '#app',
  router,
  render: h => h(App)
})

window._vuePrerender = _vue



// WEBPACK FOOTER //
// ./src/main.js